import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import s from '../../IconV2.scss';

const Close32: FC<IconV2Props> = ({ icon, chroma, className }) => (
  <svg
    className={cn(
      chroma === 'light' ? s.svgLight32 : s.svgDark32,
      `svg-icon--${icon}`,
      className
    )}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    data-icon={`${icon}-32`}
  >
    <path
      d="m16.002 14.94 7.601-7.602 1.06 1.06-7.6 7.602 7.6 7.601-1.06 1.061-7.601-7.601L8.4 24.662l-1.06-1.06L14.94 16l-7.6-7.601L8.4 7.338l7.602 7.601Z"
      fill="#000"
      fillRule="nonzero"
    />
  </svg>
);

export default Close32;
